import {Component, Inject, OnInit} from '@angular/core';
import { UntypedFormGroup} from "@angular/forms";
import {Operations} from "../../_models/Operations/Operations";
import {ApiService} from "../../_services/api.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-venue-capacity-dialog',
  templateUrl: './venue-capacity-dialog.component.html',
  styleUrls: ['./venue-capacity-dialog.component.scss']
})
export class VenueCapacityDialogComponent implements OnInit {

  venueForm: UntypedFormGroup = new UntypedFormGroup({})
  loading: boolean = false;
  venueId: string;
  capacity: number = 0;

  constructor(
    private dialogRef: MatDialogRef<VenueCapacityDialogComponent>,
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.venueId = data.venueId;
    this.initForm();
  }

  ngOnInit(): void {
  }

  private initForm() {
    this.loading = true;
    this.apiService.getVenue(this.venueId).subscribe((venue) => {
        this.capacity = venue.maximumCapacity;
      });
  }

  shareCapacity(value: number) {
    this.capacity = value
  }

  save() {
    this.loading = true
    this.apiService.updateMaximumCapacity(this.venueId, this.capacity).subscribe(response => {
      this.venueForm.reset();
      this.loading = false;
      this.dialogRef.close(false);
      this.snackBar.open('Venue successfully updated!', 'Cancel', {
        duration: 3000
      });
    },error => {
      this.loading = false;
      this.snackBar.open('Error', 'Cancel', {
        duration: 3000
      });
    });
  }

  close() {
    this.venueForm.reset();
    this.dialogRef.close(true);
  }


}
